var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfograph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.735,
    height: 68.735,
    viewBox: "0 0 68.735 68.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_248",
    "data-name": "Grupo 248",
    transform: "translate(-48.986 -673.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_727",
    "data-name": "Caminho 727",
    d: "M66.724,673.247v4.435H48.986v26.606H64.507v-2.217H52.226l4-5.708a7.41,7.41,0,0,1,12.139,0l4,5.708H66.724v39.911h51V673.247ZM54.405,695.091l-3.2,4.573V679.9H88.9v16.013l-1.389-4.455a10.157,10.157,0,0,0-19.389,0l-.38,1.217A9.619,9.619,0,0,0,54.405,695.091Zm15.769,0a9.247,9.247,0,0,0-.623-.787l.683-2.183a7.938,7.938,0,0,1,15.154,0l3.111,9.951H75.066ZM115.5,739.764H68.942V704.29H91.115V677.682H68.942v-2.218h46.564Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_728",
    "data-name": "Caminho 728",
    d: "M61.195,714.63h6.652v-13.3H61.195Zm2.217-11.086H65.63v8.868H63.412Z",
    transform: "translate(9.964 22.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_729",
    "data-name": "Caminho 729",
    d: "M66.078,718.616H72.73V696.443H66.078ZM68.3,698.661h2.217V716.4H68.3Z",
    transform: "translate(13.949 18.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_730",
    "data-name": "Caminho 730",
    d: "M70.962,716.623h6.652V698.885H70.962ZM73.179,701.1H75.4v13.3H73.179Z",
    transform: "translate(17.935 20.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    "data-name": "Caminho 731",
    d: "M75.845,714.63H82.5v-13.3H75.845Zm2.217-11.086H80.28v8.868H78.063Z",
    transform: "translate(21.92 22.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    "data-name": "Caminho 732",
    d: "M80.729,715.627h6.652V700.106H80.729Zm2.217-13.3h2.217v11.086H82.946Z",
    transform: "translate(25.906 21.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    "data-name": "Caminho 733",
    d: "M76.672,695.286a2.976,2.976,0,0,0,.042-.4,3.326,3.326,0,0,0-6.652,0,3.279,3.279,0,0,0,.334,1.424l-4.448,4.45a3.32,3.32,0,1,0-1.426,6.316,3.326,3.326,0,0,0,3.325-3.325h0a3.253,3.253,0,0,0-.334-1.424l4.45-4.45a3.271,3.271,0,0,0,3.729-.6l3.28,1.642a3.308,3.308,0,0,0,5.586,2.793l3.28,1.642a3.709,3.709,0,0,0-.04.4,3.317,3.317,0,0,0,6.62.32l2.806-.7a3.339,3.339,0,1,0-.523-2.152l-2.806.7a3.309,3.309,0,0,0-5.072-.556l-3.282-1.642a2.973,2.973,0,0,0,.042-.4,3.319,3.319,0,0,0-5.628-2.39Zm-12.154,9.576a1.109,1.109,0,1,1,1.11-1.11h0a1.113,1.113,0,0,1-1.11,1.111Zm8.87-8.87a1.109,1.109,0,1,1,1.108-1.108,1.108,1.108,0,0,1-1.108,1.108Zm26.606,4.435a1.109,1.109,0,1,1-1.11,1.11,1.108,1.108,0,0,1,1.11-1.11Zm-8.868,2.217a1.109,1.109,0,1,1-1.11,1.11h0a1.113,1.113,0,0,1,1.11-1.108Zm-8.87-4.435a1.109,1.109,0,1,1-1.108,1.11,1.111,1.111,0,0,1,1.108-1.11Z",
    transform: "translate(9.966 14.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    "data-name": "Caminho 734",
    d: "M83.382,702.97a9.978,9.978,0,1,0-9.978-9.978h0A9.99,9.99,0,0,0,83.382,702.97Zm0-17.738a7.76,7.76,0,1,1-7.762,7.76A7.76,7.76,0,0,1,83.382,685.232Z",
    transform: "translate(19.928 7.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_735",
    "data-name": "Caminho 735",
    d: "M73.4,675.689H93.358v2.217H73.4Z",
    transform: "translate(19.928 1.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_736",
    "data-name": "Caminho 736",
    d: "M73.4,678.13H93.358v2.218H73.4Z",
    transform: "translate(19.928 3.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_737",
    "data-name": "Caminho 737",
    d: "M83.171,680.572h2.217v2.218H83.171Z",
    transform: "translate(27.899 5.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_738",
    "data-name": "Caminho 738",
    d: "M73.4,680.572H88.925v2.218H73.4Z",
    transform: "translate(19.928 5.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_739",
    "data-name": "Caminho 739",
    d: "M54.753,678.13a3.326,3.326,0,1,0,3.325,3.327A3.326,3.326,0,0,0,54.753,678.13Zm0,4.435a1.109,1.109,0,1,1,1.11-1.108A1.108,1.108,0,0,1,54.753,682.565Z",
    transform: "translate(1.993 3.985)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfograph);
export default __webpack_public_path__ + "static/media/infograph.6d77afe9eabba8ac6bf68da91bb8952f.svg";
export { ForwardRef as ReactComponent };